<template>
    <video controls controlsList="nodownload" preload="auto" class="embed-file-video w-full object-cover">
        <source v-bind:src="file.url" :type="'video/' + file.extension">
        Sorry, your browser does not support the video tag. Please install a browser with support for the video tag.
    </video>
</template>

<script>

export default {
    name: 'EmbedFileVideo',
    props: ['file']
};
</script>
